const getStoredFormValues = () => {
    const stored = localStorage.getItem("formValues");
    return stored ? JSON.parse(stored) : null;
};

export const skipRoof = () => {
    const formValues = getStoredFormValues();
    if (!formValues) return false;

    if (!formValues.SkipRoof) {
        return false;
    }

    return true;
}

export const hasValidAddress = () => {
    const formValues = getStoredFormValues();
    if (!formValues) return false;

    return (
        formValues.Address?.Address &&
        formValues.Address?.Zip &&
        formValues.Address?.LatLng?.lat &&
        formValues.Address?.LatLng?.lng
    );
};

export const hasValidRoofArea = () => {
    const formValues = getStoredFormValues();
    if (!formValues) return false;

    if (formValues.SkipRoof) {
        return true;
    }

    if (!formValues.Roof?.Zones || formValues.Roof.Zones.length === 0) return false;

    return formValues.Roof.Zones.every(zone =>
        zone?.Points?.length >= 3 && zone.Tilt > 1
    );
};

export const hasValidRoofObstacle = () => {
    const formValues = getStoredFormValues();
    if (!formValues) return false;

    if (formValues.SkipRoof) {
        return true;
    }

    return formValues.Roof.Obstacles.every(obstacle =>
        obstacle?.Points?.length >= 3
    );
};
